/* ==========================================================================
   GUÍA Y AYUDA DE TAMAÑOS — Cuadros Splash

   El botón vive junto al selector de talla (product-variant-picker.liquid);
   el modal vive donde lo coloque el bloque del editor. Se enlazan por el id
   de la sección, no por cercanía en el DOM, porque no tienen por qué ser
   hermanos.
   ========================================================================== */

(function () {
  'use strict';

  function seccionDe(el) {
    var raiz = el.closest('[id^="shopify-section"]');
    return raiz ? raiz.dataset.section || raiz.id.replace('shopify-section-', '') : null;
  }

  /* Se prepara el MODAL, una vez, no el botón: el botón se rehace (ver el
     oyente del final), el modal no. */
  function iniciar(boton) {
    var id = boton.dataset.csSizeGuideOpen;
    var modal = document.getElementById('cs-size-guide-' + id);
    if (!modal) return; // el bloque de la guía no está en esta plantilla
    if (modal.__csSgAbrir) return;

    /* El cajón se saca al <body>. No es cosmético: nace dentro de
       .product__info-container, que es position:sticky con z-index:2, y eso
       crea un CONTEXTO DE APILAMIENTO. Dentro de él, el z-index del cajón
       solo compite con sus hermanos: da igual que valga 1000, todo el
       contenedor sigue estando por debajo de la cabecera (z-index:3), que le
       tapaba las pestañas y el botón de cerrar. Subir el número no podía
       arreglarlo nunca; había que salir del contexto.

       Es además donde vive el cajón del carrito de Dawn, así que los dos
       cajones acaban al mismo nivel. */
    if (modal.parentElement !== document.body) {
      // Al recargar una sección en el editor de temas nace un modal nuevo
      // dentro de la sección mientras el anterior sigue colgado del body:
      // se retira el viejo para no dejar duplicados invisibles acumulándose.
      var previo = document.querySelector('body > [data-cs-size-guide][id="cs-size-guide-' + id + '"]');
      if (previo && previo !== modal) previo.remove();
      document.body.appendChild(modal);
    }

    var caja = modal.querySelector('.cs-sg__caja');
    var focoAnterior = null;

    function focoInicial() {
      var tab = modal.querySelector('[data-cs-sg-tab].is-activa');
      if (tab) tab.focus();
    }

    /* Bug real que reportó Gabriel: si se entraba en "Cómo elegir tu talla",
       se cerraba el panel y se volvía a abrir más tarde, aparecía otra vez
       en esa pestaña en vez de volver a "Detalles del tamaño". El estado de
       las pestañas nunca se reiniciaba entre una apertura y la siguiente.
       Ahora cada apertura fuerza la primera pestaña, siempre. */
    function irAPrimeraPestana() {
      var primera = tabs[0];
      if (primera) cambiarPestana(primera);
    }

    function abrir() {
      focoAnterior = document.activeElement;
      irAPrimeraPestana();
      modal.hidden = false;
      // Dos fotogramas para que el navegador aplique translateX(100%) antes
      // de quitarlo: si se hace en el mismo, el cajón aparece de golpe en
      // vez de deslizarse.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          modal.classList.add('is-abierta');
        });
      });
      document.body.style.overflow = 'hidden';
      setTimeout(focoInicial, 260);
    }

    function cerrar() {
      modal.classList.remove('is-abierta');
      document.body.style.overflow = '';
      if (focoAnterior && document.contains(focoAnterior)) focoAnterior.focus();
      // Se oculta del todo cuando termina de deslizarse hacia fuera, para
      // que no quede recibiendo el foco del teclado mientras está invisible.
      setTimeout(function () {
        if (!modal.classList.contains('is-abierta')) modal.hidden = true;
      }, 260);
    }

    modal.__csSgAbrir = abrir;

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-cs-sg-cerrar]')) cerrar();
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrar();
    });

    /* --- Pestañas ---
       cambiarPestana() se declara ANTES de usarla en abrir()/irAPrimeraPestana()
       porque las function-declarations se izan (hoisting): en tiempo de
       ejecución ya existe, así que el orden en el fichero no es el problema
       aquí. Se separa en su propia función para poder llamarla también al
       abrir el panel, no solo al pulsar una pestaña. */
    var tabs = [].slice.call(modal.querySelectorAll('[data-cs-sg-tab]'));

    function cambiarPestana(tab) {
      var nombre = tab.dataset.csSgTab;
      tabs.forEach(function (t) {
        var activa = t === tab;
        t.classList.toggle('is-activa', activa);
        t.setAttribute('aria-selected', activa ? 'true' : 'false');
        t.tabIndex = activa ? 0 : -1;
      });
      modal.querySelectorAll('[data-cs-sg-panel]').forEach(function (panel) {
        var activo = panel.dataset.csSgPanel === nombre;
        panel.classList.toggle('is-activo', activo);
        panel.hidden = !activo;
      });
      // Otra posible causa de "no puedo volver atrás": la pestaña 2 tiene
      // mucho más contenido que la 1. Si se venía leyendo abajo del todo y
      // se cambiaba a la pestaña corta, el scroll se quedaba en una
      // posición que ya no existía en el contenido nuevo, y visualmente
      // parecía que el clic no había hecho nada.
      if (caja) caja.scrollTop = 0;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { cambiarPestana(tab); });
    });

    /* --- cm / pulgadas ---
       Ambas cifras ya están en el HTML (calculadas en Liquid, sin coma
       flotante en JS): esto solo alterna cuál se ve, así que funciona igual
       de bien si el script tarda en cargar. */
    var unidades = [].slice.call(modal.querySelectorAll('[data-cs-sg-unidad]'));
    unidades.forEach(function (u) {
      u.addEventListener('click', function () {
        var elegida = u.dataset.csSgUnidad;
        unidades.forEach(function (o) { o.classList.toggle('is-activa', o === u); });
        modal.querySelectorAll('[data-cs-sg-medida]').forEach(function (m) {
          m.hidden = m.dataset.csSgMedida !== elegida;
        });
      });
    });
  }

  function arrancar() {
    document.querySelectorAll('[data-cs-size-guide-open]').forEach(iniciar);
  }

  /* EL CLIC SE ESCUCHA EN EL DOCUMENTO, NO EN EL BOTÓN (1 nov 2026). Gabriel:
     «hay veces que no funciona el botón de la guía». Era al elegir otra
     talla: Dawn vuelve a pintar el selector de variantes con lo que le manda
     el servidor, y el botón, que vive en su leyenda, nacía nuevo y sin
     oyente. Escuchando arriba, vale cualquier botón que haya en ese momento. */
  document.addEventListener('click', function (e) {
    var boton = e.target.closest && e.target.closest('[data-cs-size-guide-open]');
    if (!boton) return;
    iniciar(boton);
    var modal = document.getElementById('cs-size-guide-' + boton.dataset.csSizeGuideOpen);
    if (modal && modal.__csSgAbrir) modal.__csSgAbrir();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();
